import { CollectionEntity } from "@busy-human/gearbox";
import { z } from "zod";
import { Events } from "../Event/index.js";
const capitalize = (s) => `${s.charAt(0).toUpperCase()}${s.slice(1)}`;
// eslint-disable-next-line no-use-before-define
function convertEventTitle(req, dogName) {
    if (req.eventType === Events.EventType.Training) {
        return `${capitalize(req.eventType)}: ${capitalize(req.trainingType)} - ${dogName}`;
    }
    else if (req.eventType === Events.EventType.PickupDropoff) {
        return `${capitalize(req.pickupType)} - ${dogName}${req.companyTransport ? ' (Transport by Company)' : ''}`;
    }
    else {
        return `${capitalize(req.eventType)} - ${dogName}`;
    }
}
export var ScheduleRequest;
(function (ScheduleRequest) {
    const BaseSchema = z.object({
        dogId: z.string(),
        userId: z.string(),
        startTime: z.string().datetime(),
        submittedAt: z.string().datetime().optional(),
        reviewedByAdmin: z.boolean(),
        agreementId: z.string(),
        agreementSigned: z.boolean().optional()
    });
    const TrainingSchema = BaseSchema.extend({
        eventType: z.literal(Events.EventType.Training),
        trainingType: Events.TrainingTypeSchema,
        fundamentalsType: Events.FundamentalsTypeSchema.optional().nullable().or(z.undefined()),
        executiveType: Events.ExecutiveTypeSchema.optional().nullable().or(z.undefined()),
        advancedType: Events.AdvancedTypeSchema.optional().nullable().or(z.undefined()),
    });
    const BoardingSchema = BaseSchema.extend({
        eventType: z.literal(Events.EventType.Boarding),
        endTime: z.string().datetime(),
        companyPickup: z.boolean().optional(),
        companyDropoff: z.boolean().optional()
    });
    const TransportSchema = BaseSchema.extend({
        eventType: z.literal(Events.EventType.PickupDropoff),
        pickupType: z.literal('pickup').or(z.literal('dropoff')),
        companyTransport: z.boolean().optional()
    });
    ScheduleRequest.Schema = z.discriminatedUnion('eventType', [TrainingSchema, BoardingSchema, TransportSchema]);
    const SEVEN = 7;
    function convertWeeksToTimestamp(startTime, weeks) {
        const t = new Date(startTime);
        return new Date(t.getFullYear(), t.getMonth(), t.getDate() + (SEVEN * weeks)).toISOString();
    }
    ScheduleRequest.convertWeeksToTimestamp = convertWeeksToTimestamp;
    const DAY_IN_MS = 8.64e+7;
    const MINUTE_IN_MS = 60000;
    /** Returns the number of nights for a boarding event */
    function eventLengthNights(req) {
        if (!('endTime' in req))
            throw new Error("Request does not include end time");
        const TZOFFSET = new Date().getTimezoneOffset() * MINUTE_IN_MS;
        const startDay = Math.floor((new Date(req.startTime).getTime() - TZOFFSET) / DAY_IN_MS);
        const endDay = Math.floor((new Date(req.endTime).getTime() - TZOFFSET) / DAY_IN_MS);
        const dif = endDay - startDay;
        const nights = Math.max(1, dif);
        // const startTime = new Date(req.startTime).getTime();
        // const endTime = new Date(req.endTime).getTime();
        // const dif = Math.abs(endTime - startTime);
        // const nights = Math.max(1, Math.floor(dif / DAY_IN_MS));
        return nights;
    }
    ScheduleRequest.eventLengthNights = eventLengthNights;
    function convertToEvent(req, endTime, dogName, trainerId) {
        const tmp = {
            dogId: req.dogId,
            endTime,
            eventType: req.eventType,
            startTime: req.startTime,
            title: convertEventTitle(req, dogName),
            userId: req.userId,
        };
        if (req.eventType === Events.EventType.Training) {
            console.log("Training stuff being set:", req);
            tmp.trainingType = req.trainingType;
            if (req.fundamentalsType)
                tmp.fundamentalsType = req.fundamentalsType;
            if (req.executiveType)
                tmp.executiveType = req.executiveType;
            if (req.advancedType)
                tmp.advancedType = req.advancedType;
        }
        if (req.eventType === Events.EventType.PickupDropoff) {
            tmp.pickupType = req.pickupType;
            if (req.companyTransport)
                tmp.companyHandled = req.companyTransport;
        }
        if (trainerId)
            tmp.trainerId = trainerId;
        return tmp;
    }
    ScheduleRequest.convertToEvent = convertToEvent;
    const HALF_HOUR = 1800000;
    function buildTransportEvents(req, dogName) {
        const dropOffEvent = {
            eventType: Events.EventType.PickupDropoff,
            dogId: req.dogId,
            pickupType: 'dropoff',
            startTime: req.startTime,
            userId: req.userId,
            companyTransport: !!req.companyPickup,
            reviewedByAdmin: !!req.reviewedByAdmin,
            agreementId: req.agreementId
        };
        const dropoffend = new Date(new Date(req.startTime).getTime() + HALF_HOUR).toISOString();
        const evt1 = convertToEvent(dropOffEvent, dropoffend, dogName, "Main");
        const pickupEvent = {
            eventType: Events.EventType.PickupDropoff,
            dogId: req.dogId,
            pickupType: 'pickup',
            startTime: req.endTime,
            userId: req.userId,
            companyTransport: !!req.companyDropoff,
            reviewedByAdmin: !!req.reviewedByAdmin,
            agreementId: req.agreementId,
        };
        const pickupend = new Date(new Date(req.endTime).getTime() + HALF_HOUR).toISOString();
        const evt2 = convertToEvent(pickupEvent, pickupend, dogName, "Main");
        return [evt1, evt2];
    }
    ScheduleRequest.buildTransportEvents = buildTransportEvents;
    function Default() {
        return {
            dogId: '',
            userId: '',
            startTime: new Date().toISOString(),
            eventType: Events.EventType.PickupDropoff,
            pickupType: 'dropoff',
            reviewedByAdmin: false,
            agreementId: '',
        };
    }
    ScheduleRequest.Default = Default;
    const Relationships = {};
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults = Default;
    }
    ScheduleRequest.CollectionClass = CollectionClass;
    ScheduleRequest.Collection = new CollectionClass({ path: '/ScheduleRequests' });
})(ScheduleRequest || (ScheduleRequest = {}));
//# sourceMappingURL=index.js.map